import React from "react";
import BusinessTabs from "./BusinessTabs";
import ServiceCard from "./ServiceCard";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FeatureIntegrateHead from "./FeatureIntegrateHead";
import Slick from "../Tabs/PlatformSlider";

const ProductLists = [
    {
        title: "실제 원본 데이터로부터 얻는 인사이트,",
        title02: " 그러면서도 탁월한 유연함",
        description: "integrate.io, https://www.integrate.io/",
        description_01:
            "모든 고객 데이터를 통합함으로서, 시간을 절약하면서도, \n" +
            "분석품질을 향상시켜,   기업 성장을 극대화합니다. \n" +
            "다양한 소스에서 데이터를 가져와 220개 이상의   \n" +
            "변환 기능을 거쳐, 데이터웨어하우스, 데이터베이스 또는 \n" +
            "업무시스템으로 데이터 를 보냅니다.",
        // description_02: "ServiceNow에서 Snowflake로 데이터를 자동으로 수집합니다. 이 커넥터는 과거 데이터의 초기 로드와 증분 업데이트를 모두 지원합니다.",
        imgSrcPd: "/img/integrate/contents_img01.png"
    },
    {
        title: "진정한 로코드,",
        title02: " 데이터 집약",
        description: "integrate.io, https://www.integrate.io/",
        description_01:
            "엔지니어와 비엔지니어 모두 몇 분 안에 데이터 파이프라인을 \n" +
            "쉽게 구축하고 관리 할 수 있습니다. \n" +
            "로코드이면서도 풍부한 표현식, 고급 API 및 웹훅을   \n" +
            "사용하여 가지고 있는 스택들을 커스터마이즈해서 \n" +
            "추가하는 것도 가능합니다.",
        // description_02: "Snowflake의 분석 기능으로 SAP 데이터에서 더 많은 가치 창출고객이 모든 데이터를 분석할 수 있는 간단하고 탄력적인 플랫폼을 제공하는 Snowflake의 플랫폼에 대해 알아보고, SAP 데이터를 Snowflake로 오프로드할 때 누릴 수 있는 이점을 알아보세요.",
        imgSrcPd: "/img/integrate/contents_img02.png"
    },
    {
        title: "여러분의 웨어하우스가 곧",
        title02: " 기업의 심장이 됩니다",
        description: "integrate.io, https://www.integrate.io/",
        description_01:
            "간단한 로코드 리버스 ETL을 통한 인사이트로 \n" +
            "실시간 의사 결정을 가능케   합니다. \n" +
            "더 나아가 고객의 늘어나는 데이터 종류와 다양한 \n" +
            "이용사례에 맞춰  함께 확장 및 진화해 가는 플랫폼입니다.",
        // description_02: "고유한 내부 애플리케이션을 만들어 IT 운영을 효율화하고 비용을 절감하고 싶으신가요? Streamlit을 사용해보세요.",
        imgSrcPd: "/img/integrate/contents_img03.png"
    }
];

const ServiceLists = [
    {
        id: 1,
        img: "/img/integrate/service_icon01.svg",
        subTitle: "의사결정을 보다\n" +
            "정교하게",
        detail: "데이터를 하나로 통합하여 비즈니스 \n" +
            "인사이트의 고도화"
    },
    {
        id: 2,
        img: "/img/integrate/service_icon02.svg",
        subTitle: "수 많은 데이터를\n" +
            "본격적으로 운용",
        detail: "적절한 데이터를 필요한 시스템에\n" +
            "격납 및 간단 운용"
    },
    {
        id: 3,
        img: "/img/integrate/service_icon03.svg",
        subTitle: "데이터 제품을 더욱\n" +
            "강력하게",
        detail: "데이터에 기반한 내부 / 외부 고객을\n" +
            "위한 서비스 개발"
    },
    {
        id: 4,
        img: "/img/integrate/service_icon04.svg",
        subTitle: "미래를 대비한\n" +
            "데이터 활용",
        detail: "데이터가 늘어나도 걱적 없는\n" +
            "데이터 플랫폼"
    }
]

const FeatureIntegrate = () => {
    return (
        <>
            <BusinessTabs current="integrate" />
            <FeatureIntegrateHead />

            <section id="1" className="scroll-mt-below-tabs md:pb-section-lg md:scroll-mt-below-tabs-md">
                <div className="container max-w-full overflow-hidden bg-gray-50 px-5 py-section-lg xl:px-0">
                    <p className="mx-auto mt-4 max-w-6xl text-h3 font-bold text-brand">
                        Process
                    </p>
                    <h1 className="mt-4 mx-auto max-w-6xl text-h1 font-bold text-gray-900">
                        노코드 ETL & 리버스 ETL 플랫폼
                    </h1>
                    <p className="m-auto mb-12 mt-4 max-w-6xl text-body font-normal text-gray-500">
                        저희의 파워풀한 드래그 앤 드롭 인터페이스를 활용하여, 여러분의 데이터를 손쉽게 변환 및 전송하세요.
                    </p>
                    <div className="mx-auto mt-8 grid max-w-6xl grid-cols-1 gap-section">
                        {ProductLists.map((list, index) => (
                            <div
                                key={list.imgSrcPd}
                                className={`flex flex-col items-center justify-between gap-8 sm:gap-20 ${
                                    index % 2 === 1 ? "sm:flex-row" : "sm:flex-row-reverse"
                                }`}
                            >
                                <div className="w-full sm:w-[48%]">
                                    <h2 className="text-h1 font-bold">
                                        {list.title}
                                        <span>{list.title02}</span>
                                    </h2>
                                    <p className="mt-6 text-body font-normal sm:mb-8">
                                        {list.description_01}
                                    </p>
                                </div>

                                <div className="w-full sm:w-[48%]">
                                    <img
                                        className={`h-auto w-full rounded-lg object-contain ${
                                            index % 2 === 1 ? "sm:float-left" : "sm:float-right"
                                        }`}
                                        src={list.imgSrcPd}
                                        alt=""
                                    />
                                    <p
                                        className={`mt-2 text-left text-caption text-gray-400 ${
                                            index % 2 === 1 ? "sm:text-right" : "sm:text-left"
                                        }`}
                                    >
                                        {list.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="container max-w-full overflow-hidden px-5 py-section-lg xl:px-0">
                    <p className="mx-auto mt-4 max-w-6xl text-h3 font-bold text-brand">
                        Service
                    </p>
                    <h1 className="mt-4 mx-auto max-w-6xl text-h1 font-bold text-gray-900">
                        모든 데이터 여정을 지원하는<br/>
                        유일한 플랫폼
                    </h1>
                    <div className="mx-auto mt-8 grid max-w-6xl grid-cols-1 gap-3.5 sm:grid-cols-2 lg:grid-cols-4">
                        {ServiceLists.map(list => (
                            <ServiceCard key={list.id} item={list} />
                        ))}
                    </div>
                </div>

                <div className="int_slide_wrap mx-auto flex max-w-6xl flex-col gap-8 overflow-hidden rounded-t-[24px] bg-gradient-to-l from-indigo-600 to-teal-400 px-6 py-14 md:gap-10 md:rounded-[50px] md:px-10 md:pb-14 md:pt-10">
                    <h1 className="text-center text-h1 font-semibold text-white">
                        ETL & Reverse <br/>ETL 플랫폼 기능
                    </h1>
                    <Slick />
                </div>
            </section>
        </>
    );
};

export default FeatureIntegrate;